import React from "react";
import useWindowDimensions from "../src/hooks/getDimensions";
import loaderImg from '../src/Assests/rocks loader.svg';

const Loader = ({ text }) => {
  const { width } = useWindowDimensions();

  return (
    <div className="position-fixed w-100"
      style={{
        zIndex: 1100,
        top: 0,
        height: "135%",
        background: "rgba(210, 210, 210, 0.80)",
        webkitBackdropFilter: "blur(5px)",
        backdropFilter: "blur(5px)",
      }}
    >
      <div className="vh-100 d-flex align-items-center justify-content-center">
        <div className="d-flex flex-column align-items-center justify-content-center">
          <img width={150} src={loaderImg} alt="loader" />
          {text && (
            <p className="text-dark mt-3 text-center" style={{ fontWeight: '500' }}>
              {text}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default Loader;
